// lib/inquiry-price.ts
// قیمت‌ها در دیتابیس به ریال هستند (مطابق priceCurrency: IRR در اسکیمای سایت)

export const PRICE_UNIT = "تومان";

/** قیمت معتبر یعنی عددی بزرگ‌تر از صفر؛ در غیر این صورت «استعلام» */
export const hasPrice = (price?: number | string | null): boolean => {
    const n = Number(price);
    return Number.isFinite(n) && n > 0;
};

export const toPrice = (price?: number | string | null): number =>
    hasPrice(price) ? Math.round(Number(price)) : 0;

export const formatPriceFa = (price: number): string => price.toLocaleString("fa-IR");
